import { render, staticRenderFns } from "./EditEnvio.vue?vue&type=template&id=0a06fdf2"
import script from "./EditEnvio.vue?vue&type=script&lang=js"
export * from "./EditEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports